import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from '@angular/material/select';
import { OrganisationDto, TypeSportEnum, typeSportEnumText } from '@aoe/client';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { EventAdminActions } from 'src/app/core/store/admin/event-admin/event-admin.actions';
import { selectOrganisation } from 'src/app/core/store/organisation/organisation.selector';

@Component({
  selector: 'aoe-init-event-dialog',
  imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule, AsyncPipe, MatButtonModule, MatInputModule],
  templateUrl: './init-event-dialog.component.html',
  styleUrl: './init-event-dialog.component.scss',
})
export class InitEventDialogComponent implements OnInit {

  organisations$!: Observable<OrganisationDto[]>;
  eventFg!: FormGroup;
  typeOfSport = Object.keys(TypeSportEnum).map(key => ({
    key: key,
    value: TypeSportEnum[key as keyof typeof TypeSportEnum]
  }));

  typeSportEnumText = typeSportEnumText;

  constructor(
    private readonly store: Store,
    private readonly fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.eventFg = this.fb.group({
      name: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.minLength(3), Validators.maxLength(150)] }),
      organisationId: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
      typeSport: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
      code: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.minLength(3), Validators.maxLength(3)] }),
      startDate: new FormControl<Date>(new Date(), { nonNullable: true, validators: [Validators.required] }),

    })
    this.organisations$ = this.store.select(selectOrganisation).pipe(tap(orgs => { if (orgs.length === 1) { this.eventFg.get('organisationId')?.setValue(orgs[0].id); this.eventFg.get('organisationId')?.disable() } }));
  }

  submit() {
    this.store.dispatch(EventAdminActions['createEvent']({ payload: { ...this.eventFg.value, organisationId: this.eventFg.get('organisationId')?.value } }));
  }

}
